<template>
  <div id="login">
    <div class="pc">
      <div class="form-group">
        <el-form ref="form" :model="form" class="form">
          <el-form-item class="input">
            <el-input v-model="form.phone" clearable placeholder="手机号"></el-input>
          </el-form-item>
          <el-form-item class="input">
            <el-input
              v-model="form.password"
              type="password"
              clearable
              placeholder="密码"
              @keyup.enter.native="onsubmit"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="senkoo" :disabled="!isFill" @click="onsubmit" class="login">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
      <span class="copyright">版权所有 © SENKOO. All rights reserved. 沪ICP备18042729号-1</span>
    </div>
    <div class="mobile">
      <el-form ref="form" :model="form" class="form">
        <figure>
          <template v-if="false">
            <img src="@/assets/logo.png" class="icon" />
            <figcaption>instant messaging</figcaption>
          </template>
        </figure>
        <el-form-item class="input">
          <el-input v-model="form.phone" clearable placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item class="input">
          <el-input
            v-model="form.password"
            type="password"
            clearable
            placeholder="密码"
            @keyup.enter.native="onsubmit"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="senkoo" :disabled="!isFill" @click="onsubmit" class="login">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {}
    };
  },
  computed: {
    isFill() {
      return this.form.phone && this.form.password;
    }
  },
  methods: {
    onsubmit() {
      this.$api.login(this.form).then(res => {
        console.log("+=", res);
        if (res.code == 200) {
          localStorage.setItem("user", JSON.stringify(res.result.user));
          localStorage.setItem("token", res.result.token);
          this.$router.push({ path: "/" });
        } else {
          this.$message.error({ message: res.msg });
        }
      });
    }
  }
};
</script>
<style lang='scss' scoped>
#login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  background: #f8f8f8;
  position: relative;
  .pc {
    display: block;
    .form-group {
      width: 900px;
      height: 560px;
      background: url(../assets/back-login.png) top/100% no-repeat;
      margin: 0 auto;
      // border: 1px dashed red;
      position: relative;
      box-shadow: -4px 8px 40px 0 rgba(39, 176, 175, 0.23);
      .form {
        width: 380px;
        padding: 0 60px;
        position: absolute;
        right: 0;
        top: 215px;
        // border: 1px dashed red;
        .input {
          /deep/ .el-input__inner {
            background-color: transparent;
            border: none;
            border-radius: 0;
            border-bottom: 1px solid #ddd;
            color: #fff;
            font-size: 14px;
            padding-left: 0;
          }
          /deep/ .el-input__inner::placeholder {
            color: #dcdcdc;
          }
        }
        .login {
          margin-top: 30px;
          width: 260px;
          height: 45px;
          border-radius: 4px;
        }
      }
    }
    .copyright {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 14px;
      color: hsla(0, 0%, 20%, 1);
    }
  }
  .mobile {
    display: none;
  }
}
@media screen and(max-width: 750px) {
  #login {
    .pc {
      display: none;
    }
    .mobile {
      display: block;
      height: 100vh;
      background: url(../assets/login-back-mobile.png) no-repeat center center
        fixed;
      background-size: cover;
      // border: 1px dashed;
      .form {
        // border: 1px dashed;
        padding: 20vh 40px 0;
        figure {
          text-align: center;
          margin: 0 0 50px;
          width: 295px;
          height: 132px;
          img {
            height: 70px;
            object-fit: contain;
            filter: brightness(100);
          }
          figcaption {
            margin-top: 20px;
            color: #fff;
            text-transform: uppercase;
            font-weight: bold;
            font-size: 26px;
          }
        }
        .input {
          /deep/ .el-input__inner {
            background-color: transparent;
            border: none;
            border-radius: 0;
            border-bottom: 1px solid #ddd;
            color: #fff;
            font-size: 14px;
            padding-left: 0;
          }
          /deep/ .el-input__inner::placeholder {
            color: #dcdcdc;
          }
        }
        .login {
          margin-top: 30px;
          width: 100%;
          height: 45px;
          border-radius: 23px;
        }
      }
    }
  }
}
</style>
